import React, { useState ,useEffect} from "react";
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import StepFlowProcess from "./StepFlowProcess";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
// import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
// import Typography from '@mui/material/Typography';


import FetchApi from'../../../customhooks/Functionapi';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function PopUpViewFlowstatus(props) {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <React.Fragment>
          
                <div onClick={handleClickOpen('paper')} style={{cursor:'pointer'}}>
                     <Tooltip title="flow" placement="top-start">
                    <AccountTreeIcon  style={{width:25,height:25}} color="warning"/> 
                    </Tooltip>
                </div>

            <Dialog
                // fullScreen
                TransitionComponent={Transition}
                open={open}
                onClose={handleClose}
                scroll={scroll}
                maxWidth="sm"
                fullWidth
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
            >

                <Box sx={{
                    display: 'flex', alignItems: 'center', gap: 1.5, px: 2.5, py: 2,
                    background: 'linear-gradient(135deg, #1e88e5 0%, #43a047 100%)',
                    color: '#fff',
                }}>
                    <Box sx={{
                        width: 40, height: 40, borderRadius: 2,
                        bgcolor: 'rgba(255,255,255,0.2)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <AccountTreeIcon />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Typography id="scroll-dialog-title" sx={{ fontWeight: 700, fontSize: 18, lineHeight: 1.2 }}>
                            ลำดับการอนุมัติ
                        </Typography>
                        <Typography sx={{ fontSize: 12, opacity: 0.85 }}>
                            ติดตามสถานะเอกสารในแต่ละขั้นตอน
                        </Typography>
                    </Box>
                    <IconButton onClick={handleClose} aria-label="close" sx={{ color: '#fff', '&:hover': { bgcolor: 'rgba(255,255,255,0.15)' } }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <DialogContent sx={{ bgcolor: '#fafbfc', p: 2.5 }}>
                    <StepFlowProcess jourID={props.jourId} />
                </DialogContent>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2.5, py: 1.5, borderTop: '1px solid #e3e6ea' }}>
                    <Button autoFocus variant="contained" onClick={handleClose} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, boxShadow: 'none' }}>
                        ปิด
                    </Button>
                </Box>
            </Dialog>
        </React.Fragment>
    )
}
